import isVirtual from 'Sportsbook/helpers/is_virtual';

export default (sportEventPathId, outcome) => (
  isVirtual(sportEventPathId)
    ? [outcome.raceNumber, outcome.desc].join(' ')
    : outcome.desc
);
